import type { ISaveAdapter, PlatformKey } from "../types";

export class LocalStorageAdapter implements ISaveAdapter {
  readonly platform: PlatformKey = "browser";

  async read(key: string): Promise<string | null> {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  async write(key: string, value: string): Promise<void> {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Storage quota exceeded or blocked. Silent — MemoryAdapter can pick up.
    }
  }

  async clear(key: string): Promise<void> {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // ignored
    }
  }
}
